var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Axios from 'axios';
import messageTypeDecorator from '../reflect/messageTypeDecorator';
var HomeService = (function () {
    function HomeService() {
    }
    HomeService.prototype.getWarnData = function () {
        return Axios.get('supplierclientapi/home/warning');
    };
    HomeService.prototype.getBusData = function (params) {
        return Axios.get('supplierclientapi/home/todo', { params: params });
    };
    HomeService.prototype.getDycData = function () {
        return Axios.get('supplierclientapi/home/business_dynamic');
    };
    HomeService.prototype.getIncomeData = function () {
        return Axios.get('supplierclientapi/home/supplier_payment');
    };
    HomeService.prototype.getStockWarning = function () {
        return Axios.get('supplierclientapi/home/stock_warning');
    };
    HomeService.prototype.getUpdateInfo = function (params) {
        return Axios.get('supplierclientapi/appinfo', { params: params });
    };
    HomeService.prototype.getSalesAnalyze = function (params) {
        return Axios.get('supplierclientapi/home/sales_analyze', { params: params });
    };
    HomeService.prototype.getApplyOrderData = function (params) {
        return Axios.get('supplierclientapi/home/shop_purchase_status', { params: params });
    };
    HomeService.prototype.exportApplyOrderData = function (params) {
        return Axios.get('supplierclientapi/home/shop_purchase_status_export', { params: params });
    };
    HomeService.prototype.getPurchaseTop = function (params) {
        return Axios.get('supplierclientapi/home/shop_purchase_top', { params: params });
    };
    HomeService.prototype.getJoinCustomer = function (params) {
        return Axios.get('supplierclientapi/home/franchisee_warning', { params: params });
    };
    HomeService.prototype.getSummaryInfo = function () {
        return Axios.get('supplierclientapi/home/summary_info');
    };
    HomeService.prototype.exportLogList = function (params) {
        return Axios.get('supplierclientapi/supplier_export_log/list', { params: params });
    };
    HomeService.prototype.exportLogDownload = function (params) {
        return Axios.get('supplierclientapi/supplier_export_log/download', { params: params });
    };
    HomeService.prototype.exportLogRetry = function (params) {
        return Axios.get('supplierclientapi/supplier_export_log/retry', { params: params });
    };
    HomeService.createInstance = function () {
        HomeService.getInstance();
    };
    HomeService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    HomeService.prototype.getRouteList = function (params) {
        return Axios.get('supplierclientapi/route/list', { params: params });
    };
    __decorate([
        messageTypeDecorator
    ], HomeService.prototype, "getDycData", null);
    return HomeService;
}());
export default HomeService;
